import { Component, signal, inject, HostListener, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';
import { SocketService } from '../services/socket.service';
import { GPTAssistantComponent } from '../components/gpt-assistant/gpt-assistant';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive, GPTAssistantComponent],
  templateUrl: './layout.html',
  styleUrl: './layout.css',
})
export class LayoutComponent implements OnDestroy {
  private authService = inject(AuthService);
  private notificationService = inject(NotificationService);
  private socketService = inject(SocketService);
  
  menuOpen = signal(false);
  currentUser = this.authService.currentUser;
  userPlan = this.authService.userPlan; // Exponer el plan del usuario

  toggleMenu() {
    this.menuOpen.set(!this.menuOpen());
  }

  closeMenu() {
    this.menuOpen.set(false);
  }

  logout() {
    this.notificationService.info(
      'Sesión Cerrada',
      'Has cerrado sesión exitosamente'
    );
    this.authService.logout();
  }

  /**
   * Desconectar socket cuando se cierra la pestaña o navegador
   * NOTA: beforeunload solo se dispara al cerrar la ventana/pestaña, no al navegar internamente
   */
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: BeforeUnloadEvent) {
    console.log('⚠️ beforeunload disparado - cerrando pestaña/navegador');
    if (this.socketService.estaConectado()) {
      console.log('🔌 Desconectando socket por cierre de pestaña...');
      this.socketService.desconectar();
    }
    // No es necesario return o preventDefault para este caso
  }

  /**
   * NO desconectar socket en ngOnDestroy porque el layout puede recrearse
   * durante la navegación normal. El socket solo debe desconectarse:
   * 1. Al hacer logout (manejado en AuthService)
   * 2. Al cerrar la pestaña/navegador (manejado en beforeunload)
   */
  ngOnDestroy() {
    console.log('🧹 LayoutComponent destruido (NO desconectando socket)');
  }
}

